import React from 'react';

const BlankPage = () => <> </>;

export default BlankPage;
